export default __webpack_public_path__ + "static/media/ico_external_link.e3c9bd08.svg";